import React, { useEffect } from "react";
import GamesContainer from "../components/games/games_container/GamesContainer";
import { useLocation, useParams } from "react-router-dom";
import { useAppSelector } from "../store/index.ts";
import GameItemSupportBonus from "../components/mui/game_tem/GameItemSupportBonus";
import { API_CASINO } from "../api/casino.js";
import { useDispatch } from "react-redux";
import { setCategoryGamesById } from "../store/gamesSlice.js";

export default function Categories() {
  const dispatch = useDispatch();
  const location = useLocation();
  const to = location?.state?.to;
  const { categoryId } = useParams();
  const curCategory = useAppSelector((state) => state.games.categoryById[categoryId] || {});

  const categoryName = curCategory?.name;
  const games = curCategory?.games || [];

  useEffect(() => {
    if (!categoryId) return;
    API_CASINO.list
      .categoryGames({ categoryId: +categoryId })
      .then((e) => {
        const list = e.data.list;
        dispatch(setCategoryGamesById({ id: categoryId, data: list }));
      })
      .catch(console.error);
  }, [categoryId]);

  return (
    <GamesContainer backLink={to} title={categoryName}>
      <div className="games__games">
        {games.map((el) => (
          <GameItemSupportBonus currentGame={el} key={el.game_id} name={el.name} image={el.image} />
        ))}
      </div>
    </GamesContainer>
  );
}
